import { useEffect } from "react"

import { Form } from "react-bootstrap"

import CHSService from "./CHSService"
import AccountService from "../../../../api/Administration/Model/AccountService"
import Service, { IsServiceActive, IsServiceCodeCHSBL } from "../../../../api/Administration/Model/Service"
import { ServiceCode } from "../../../../api/LookupCodes/ServiceCode"
import { ServiceDataModel } from "../../OrderModels"

interface CHSServicesProps {
  services: ServiceDataModel[]
  orderableServices: Service[]
  selectedServices: Service[]
  accountServices: AccountService[]
  canAddDOT: boolean
  canAddNonDOT: boolean
  canAddMarketplace: boolean
  canAddNotMarketplace: boolean
  onSelectService: (serviceCode: ServiceCode, add: boolean) => void
}

function CHSServices(props: CHSServicesProps) {
  const {
    services,
    orderableServices,
    selectedServices,
    accountServices,
    canAddDOT,
    canAddNonDOT,
    canAddMarketplace,
    canAddNotMarketplace,
    onSelectService,
  } = props

  useEffect(() => {
    if (orderableServices.length === 1 && selectedServices.length === 0) {
      onSelectService(orderableServices[0].FFServiceCode as ServiceCode, true)
    }
  }, [onSelectService, selectedServices, orderableServices])

  const isSelected = (service: Service) => {
    return !!selectedServices.find((item) => item.FFServiceCode === service.FFServiceCode)
  }

  const isDisabled = (service: Service) => {
    return (
      !IsServiceActive(service, accountServices) ||
      services.filter((item) => item.serviceCode === service.FFServiceCode).length > 0 ||
      !IsServiceCodeCHSBL(service.FFServiceCode) ||
      (service.DOT && !canAddDOT) ||
      (!service.DOT && !canAddNonDOT) ||
      (service.Marketplace && !canAddMarketplace) ||
      (!service.Marketplace && !canAddNotMarketplace)
    )
  }

  return (
    <Form.Group>
      {orderableServices.map((service) => (
        <CHSService
          key={service.ServiceID}
          service={service}
          selected={isSelected(service)}
          disabled={isDisabled(service)}
          onSelectService={onSelectService}
        />
      ))}
    </Form.Group>
  )
}

export default CHSServices
